import React from 'react';
import { GlassCard } from '../../ui/Card';

const AboutMeSkeleton: React.FC = () => {
    return (
        <section className="section about-me-section">
            <div className="container about-grid">
                <div className="about-text">
                    <div className="skeleton-line skeleton-title" style={{ width: '50%', height: '32px', marginBottom: '20px' }}></div>
                    <div className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                    <div className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                    <div className="skeleton-line skeleton-short" style={{ marginBottom: '20px' }}></div>
                    <div className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                    <div className="skeleton-line skeleton-short" style={{ marginBottom: '20px' }}></div>
                </div>
                <div className="about-stats">
                    <GlassCard>
                        <div className="skeleton-line skeleton-title" style={{ width: '60%', height: '32px', marginBottom: '12px' }}></div>
                        <div className="skeleton-line" style={{ width: '80%', height: '16px' }}></div>
                    </GlassCard>
                    <GlassCard>
                        <div className="skeleton-line skeleton-title" style={{ width: '50%', height: '32px', marginBottom: '12px' }}></div>
                        <div className="skeleton-line" style={{ width: '70%', height: '16px' }}></div>
                    </GlassCard>
                </div>
            </div>
        </section>
    );
};

export default AboutMeSkeleton;
